import { ITourBookingResponses } from '@llws/lift-entity-interfaces';
import { convertQueryCommandToQueryString, IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';
import { IAction, IStateStrict } from '@/shared/interfaces/store-base';
import vm from '@/main';
import { adminRequest } from '@/shared/request-configs/admin-request';

// Base store configuration
const agentGatewayResourcePathAgent: string = '/tour-api-agent/tour_booking_responses';
const adminGatewayResourcePathAdmin: string = '/tour-api-admin/tour_booking_responses';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  alias: 'tbr',
  relations: [
    {
      path: 'tbr.building',
      alias: 'b',
    },
    {
      path: 'tbr.user',
      alias: 'u',
    },
  ],
  select: [
    'tbr.id',
    'tbr.buildingId',
    'tbr.userId',
    'tbr.followUpStatus',
    'tbr.startTime',
    'tbr.endTime',
    'tbr.source',
    'tbr.fullSource',
    'tbr.spamScore',
    'tbr.comments',
    'tbr.name',
    'tbr.email',
    'tbr.phone',
    'tbr.otherData',
    'tbr.clientId',
    'tbr.rating',
    'b.buildingName',
    'b.clientId',
    'u.id',
    'u.firstName',
    'u.lastName',
    'tbr.created',
  ],
};
const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<ITourBookingResponses>({
  adminGatewayResourcePath: agentGatewayResourcePathAgent,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },
  actions: {
    ...base.actions,
    search: async (ctx: IAction<IStateStrict<ITourBookingResponses>>, payload: IQueryCommandOptions) => {
      const result = await adminRequest.post<ITourBookingResponses[]>(`${vm()?.$rsGlobals.$userHasAtLeastOneAccess('tour_admins', 'read')
        ? adminGatewayResourcePathAdmin : agentGatewayResourcePathAgent}/_search`, {
        ...defaultGetListFilters,
        ...payload,
        alias: 'tbr',
      });
      ctx.commit('set', result.data);
      return result;
    },
    getAgentTourBookingResponses: async (ctx: IAction<IStateStrict<ITourBookingResponses>>, payload: IQueryCommandOptions) => {
      const where = payload.where ?? [];
      const queryCommand: IQueryCommandOptions = payload ? { ...defaultGetListFilters, ...payload, where } : { ...defaultGetListFilters, where };
      const response = await adminRequest.get(`${vm()?.$rsGlobals.$userHasAtLeastOneAccess('tour_admins', 'read')
        ? adminGatewayResourcePathAdmin : agentGatewayResourcePathAgent}${convertQueryCommandToQueryString(queryCommand)}`);
      ctx.commit('set', response.data);
    },
  },
};
